//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Kocher',
  data() {
    return {
      defaultJson:{
        "Non weight-bearing on joint": "关节无法负重",
        "Prob. of Septic Arthritis: >99%": "化脓性关节炎可能性 > 99%",
        "Fever": "发热",
        "Prob. of Septic Arthritis: 40%": "化脓性关节炎可能性：40%",
        "Prob. of Septic Arthritis <0.2%": "化脓性关节炎可能性 < 0.2%",
        "Prob. of Septic Arthritis: 93%": "化脓性关节炎可能性：93%",
        "ESR > 40": "ESR > 40 mm\/h",
        "WBC > 12 Giga\/L (12 000 c\/mm³)": "WBC > 12 x 10⁹ \/L（12 000 c\/mm³）",
        "Prob. of Septic Arthritis: 3%": "化脓性关节炎可能性：3%"
      },
      form:{
        esr:'0',
        wbc:'0',
        bearing:'0',
        fever:'0'
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        let result = form.esr + form.wbc + form.bearing + form.fever
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/Kocher.vue